import React, { useState, useEffect, useContext } from 'react';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Layout from 'components/sales/layout/layout';
import CampForm from 'components/brandActivation/campForm/campForm';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { useParams } from 'react-router-dom';

const ScheduleAMeeting = ({
  pocList,
  getPocList,
  getCampList,
  createCamp,
  updateMeeting,
  match,
  history,
  meetingById = null,
  getMeetingById,
  documentUploadUrl,
  documentUrlData,
}) => {
  const { id } = useParams();
  const [isFiled, setIsFiled] = useState(false);
  const [siteId, setSiteId] = useState(null);
  const { baseUrl } = useContext(BaseUrl);
  const [noOfCamp, setNoOfCamp] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const inputs = {
    meetingDetails: null,
  };
  const [isModal, setIsModal] = useState(false);
  const [meetingData, setCorporateData] = useState(inputs);
  const handleForm = (val) => {
    setCorporateData({ ...meetingData, meetingDetails: val });
  };
  const handleSubmit = () => {
    const { meetingDetails } = meetingData;
    if (meetingDetails === null) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);
      (async () => {
        const res = (await id)
          ? updateMeeting(meetingDetails)
          : createCamp(meetingDetails);
        if (res) {
          setIsModal(true);
        }
      })();
    }
  };
  useEffect(() => {
    if (match.params.siteId) {
      setSiteId(match.params.siteId);
    }
  }, [match.params.siteId]);

  useEffect(() => {
    if (siteId) {
      (async () => {
        setIsLoading(true);
        await getPocList(siteId);
        setIsLoading(false);
      })();
    }
  }, [siteId, getPocList]);

  useEffect(() => {
    if (siteId) {
      (async () => {
        setIsLoading(true);
        let res = await getCampList(siteId);
        if (res?.resultSets) {
          setNoOfCamp(res?.resultSets?.length);
        }
        setIsLoading(false);
      })();
    }
  }, [getCampList, siteId]);

  useEffect(() => {
    (async () => {
      if (id) {
        setIsLoading(true);
        await getMeetingById(id);
        setIsLoading(false);
      }
    })();
  }, [getMeetingById, id]);

  const handleModalHide = () => {
    setIsModal(false);
    history.push(`${baseUrl}/brand-activation/conduct-camp/camp/${siteId}`);
  };

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.scheduleCampMeeting}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  return (
    <Layout
      title={localization.scheduleCampMeeting}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/conduct-camp/camp/${siteId}`}
    >
      <CampForm
        pocList={pocList?.resultSets}
        handleValue={handleForm}
        siteId={siteId}
        meetingById={id ? meetingById : null}
        noOfCamp={noOfCamp}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
      />
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.campSuccess}</h5>
          <Button onClick={handleModalHide} className="btn btn-primary mb-4">
            {localization.goToCampListing}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
    </Layout>
  );
};

ScheduleAMeeting.propTypes = {};

export default ScheduleAMeeting;
